/**
 *
 * key
 *
 */

 const key = 'ZnJlZWxhbmNlckF1ZGl0UWM='

 export default key
 